var map = {
	"./ESP.js": "./adsk_modules/cio-config/localization/ESP.js",
	"./KOR.js": "./adsk_modules/cio-config/localization/KOR.js",
	"./de.js": "./adsk_modules/cio-config/localization/de.js",
	"./en.js": "./adsk_modules/cio-config/localization/en.js",
	"./fr.js": "./adsk_modules/cio-config/localization/fr.js",
	"./it.js": "./adsk_modules/cio-config/localization/it.js",
	"./ja.js": "./adsk_modules/cio-config/localization/ja.js",
	"./pl.js": "./adsk_modules/cio-config/localization/pl.js",
	"./pt.js": "./adsk_modules/cio-config/localization/pt.js",
	"./tr.js": "./adsk_modules/cio-config/localization/tr.js",
	"./zh.js": "./adsk_modules/cio-config/localization/zh.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./adsk_modules/cio-config/localization sync recursive ^\\.\\/.*\\.js$";